import {Component, OnInit} from '@angular/core';

import {combineLatest} from 'rxjs';

import {MatCheckboxChange} from '@angular/material/checkbox';

import {MatDialog} from '@angular/material/dialog';
import {UserFieldDialogComponent} from './user-field-dialog/user-field-dialog.component';
import {AuthorisationService} from '../../../services/auth/authorisation.service';
import {Feature} from '../../../classes/feature.class';
import {Role} from '../../../classes/role.class';
import {RoleFeature} from '../../../classes/rolefeature.class';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-auth-roles',
    templateUrl: './auth-roles.component.html',
    styleUrls: ['./auth-roles.component.scss']
})
export class AuthRolesComponent implements OnInit {

    public roles: Role[];
    public features: Feature[];

    public featureHasRoleMatrix: FeatureHasRole[];
    public disabled = true;

    constructor(private authorisationService: AuthorisationService,
                private dialog: MatDialog,
                private title: Title) {
    }

    ngOnInit(): void {
        this.title.setTitle('Rechtenmatrix - TSNed App');
        this.disabled = false; // todo check feature
        this.initMatrix();
    }

    checkFeature(event: MatCheckboxChange, feature: Feature, role: Role) {
        if (event.checked) {
            this.authorisationService.addFeatureToRole(feature.key, role.key).subscribe();
        } else {
            this.authorisationService.removeFeatureFromRole(feature.key, role.key).subscribe();
        }
    }

    setUserFieldForFeature(event, featureHasRole: FeatureHasRole, role: Role) {
        event.preventDefault();
        let roleFeature = featureHasRole.hasRoles.get(role.key);
        if (!roleFeature) {
            roleFeature = new RoleFeature();
            roleFeature.role_key = role.key;
            roleFeature.feature_key = featureHasRole.feature.key;
        }
        const dialogRef = this.dialog.open(UserFieldDialogComponent, {
            panelClass: 'confirm-dialog',
            disableClose: true,
            data: {roleFeature: roleFeature, role}
        });
        let subs = dialogRef.afterClosed().subscribe(() => {
            this.initMatrix();
            subs.unsubscribe();
        });
    }

    private initMatrix() {
        const roles$ = this.authorisationService.getRoles();
        const features$ = this.authorisationService.getFeatures();
        combineLatest([roles$, features$]).subscribe(([roles, features]) => {
            this.roles = roles;
            this.features = features;
            this.featureHasRoleMatrix = [];
            features.forEach(feature => {
                const featureHasRole = new FeatureHasRole();
                featureHasRole.feature = feature;
                featureHasRole.hasRoles = new Map<string, RoleFeature>();
                feature.role_features.forEach(rf => {
                    featureHasRole.hasRoles.set(rf.role_key, rf);
                });
                this.featureHasRoleMatrix.push(featureHasRole);
            });
        });
    }
}

export class FeatureHasRole {
    public feature: Feature;
    public hasRoles: Map<string, RoleFeature>;

}
